import axios from 'axios';

const SERVER = process.env.REACT_APP_SERVER;

// 교육 목록 조회 API
export const getLectureList = async () => {
    return await axios.get(`${SERVER}/api/lecture/list`);
};